import { GET, POST, PATCH, DELETE, POST_FORM } from "../config";

// Tarifarios
export const list = async (page = 1, filters = {}) => {
  let url = `inventory/tariffs/?page=${page}`;

  if (filters.branch) {
    url += `&branch=${filters.branch}`;
  }

  if (filters.product) {
    url += `&product=${filters.product}`;
  }

  if (filters.is_active !== undefined) {
    url += `&is_active=${filters.is_active}`;
  }

  const response = await GET(url);
  return response.data;
};

export const create = async (data) => {
  const response = await POST("inventory/tariffs/", data);
  return response;
};

export const update = async (id, data) => {
  const response = await PATCH(`inventory/tariffs/${id}/`, data);
  return response;
};

export const destroy = async (id) => {
  const response = await DELETE(`inventory/tariffs/${id}/`);
  return response;
};

export const calculate = async (data) => {
  const response = await POST("inventory/tariffs/calculate/", data);
  return response.data;
};

export const getRanges = async (tariffId) => {
  const response = await GET(`inventory/tariffs/${tariffId}/ranges/`);
  return response.data;
};

// Rangos de Tarifarios
export const listRanges = async (tariffId) => {
  const response = await GET(`inventory/tariff-ranges/?tariff_id=${tariffId}`);
  return response.data;
};

export const createRange = async (data) => {
  const response = await POST("inventory/tariff-ranges/", data);
  return response;
};

export const updateRange = async (id, data) => {
  const response = await PATCH(`inventory/tariff-ranges/${id}/`, data);
  return response;
};

export const destroyRange = async (id) => {
  const response = await DELETE(`inventory/tariff-ranges/${id}/`);
  return response;
};

// Descuentos
export const listDiscounts = async (page = 1, filters = {}) => {
  let url = `inventory/discounts/?page=${page}`;

  if (filters.branch) {
    url += `&branch=${filters.branch}`;
  }

  if (filters.is_active !== undefined) {
    url += `&is_active=${filters.is_active}`;
  }

  const response = await GET(url);
  return response.data;
};

export const createDiscount = async (data) => {
  const response = await POST("inventory/discounts/", data);
  return response;
};

export const updateDiscount = async (id, data) => {
  const response = await PATCH(`inventory/discounts/${id}/`, data);
  return response;
};

export const destroyDiscount = async (id) => {
  const response = await DELETE(`inventory/discounts/${id}/`);
  return response;
};

export const getDiscountRanges = async (discountId) => {
  const response = await GET(`inventory/discounts/${discountId}/ranges/`);
  return response.data;
};

export const getDiscountBeneficiaries = async (discountId) => {
  const response = await GET(
    `inventory/discounts/${discountId}/beneficiaries/`
  );
  return response.data;
};

// Rangos de Descuentos
export const listDiscountRanges = async (discountId) => {
  const response = await GET(
    `inventory/discount-ranges/?discount_id=${discountId}`
  );
  return response.data;
};

export const createDiscountRange = async (data) => {
  const response = await POST("inventory/discount-ranges/", data);
  return response;
};

export const updateDiscountRange = async (id, data) => {
  const response = await PATCH(`inventory/discount-ranges/${id}/`, data);
  return response;
};

export const destroyDiscountRange = async (id) => {
  const response = await DELETE(`inventory/discount-ranges/${id}/`);
  return response;
};

// Beneficiarios
export const listBeneficiaries = async (page = 1, filters = {}) => {
  let url = `inventory/beneficiary-discounts/?page=${page}`;

  if (filters.discount) {
    url += `&discount=${filters.discount}`;
  }

  if (filters.user) {
    url += `&user=${filters.user}`;
  }

  if (filters.is_active !== undefined) {
    url += `&is_active=${filters.is_active}`;
  }

  const response = await GET(url);
  return response.data;
};

export const createBeneficiary = async (data) => {
  const response = await POST("inventory/beneficiary-discounts/", data);
  return response;
};

export const updateBeneficiary = async (id, data) => {
  const response = await PATCH(`inventory/beneficiary-discounts/${id}/`, data);
  return response;
};

export const destroyBeneficiary = async (id) => {
  const response = await DELETE(`inventory/beneficiary-discounts/${id}/`);
  return response;
};

export const getBeneficiariesByUser = async (userId) => {
  const response = await GET(
    `inventory/beneficiary-discounts/by_user/?user_id=${userId}`
  );
  return response.data;
};

// Puntos de medición
export const getMeasurementPoints = async (filters = {}) => {
  const response = await GET("inventory/measurement-points/", filters);
  return response.data;
};

export const bulkImport = async (file, branch = null) => {
  let url = "inventory/tariffs/bulk_import/";
  if (branch) {
    url += `?branch=${branch}`;
  }

  const response = await POST_FORM(url, {
    file,
  });
  return response.data;
};
